import { useRef, useState, useEffect } from 'react';

function useEventWrapper(onEvent, offEvent) {
  const [value, setValue] = useState(false);

  const ref = useRef(null);

  const handleOnEvent = () => setValue(true);
  const handleOffEvent = () => setValue(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener(onEvent, handleOnEvent);
      node.addEventListener(offEvent, handleOffEvent);

      return () => {
        node.removeEventListener(onEvent, handleOnEvent);
        node.removeEventListener(offEvent, handleOffEvent);
      };
    }
  });

  return [ref, value];
}

export function useHover() {
  return useEventWrapper('mouseover', 'mouseout');
}

export function useActive() {
  return useEventWrapper('mousedown', 'mouseup');
}

export function useFocus() {
  return useEventWrapper('focus', 'blur');
}
